export const SOURCE_OFFERS = 'offers';

// Minimum zoom level when offers are shown
export const MIN_ZOOM = 2;

export const CLUSTER_MAX_ZOOM = 12;
